module.exports = __webpack_public_path__ + "img/er.83de395b.png";